module.exports = __webpack_public_path__ + "img/ico-selling-beginning-done.cc9cb97c.svg";